import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledIdentifyDevice } from './IdentifyDevice.styles';
import { ManualEntry } from './components/ManualEntry/ManualEntry';
import { BarcodeScanner } from './components/BarcodeScanner/BarcodeScanner';
import { KccButton } from 'lib/components/KccButton/KccButton';
import { useServiceRequestContext } from 'app/modules/service/context/ServiceContext';
import { IS_DESKTOP } from 'app/modules/service/utils/constants';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

export const IdentifyDevice = (): JSX.Element => {
  const { t } = useTranslation();
  const [showManual, setShowManual] = useState(IS_DESKTOP);
  const [isNextEnabled, setIsNextEnabled] = useState(false);

  const { handleAddServiceCaseNext } = useServiceRequestContext();

  const handleSwitchToManual = (): void => {
    setShowManual(true);
    setIsNextEnabled(false);
  };

  const handleSwitchToScanner = (): void => {
    setShowManual(false);
    setIsNextEnabled(false);
  };

  return (
    <StyledIdentifyDevice className="identify-device">
      <h2 className="identify-device__title">{t('service.steps.identifyDevice')}</h2>
      <p className="identify-device__subtitle">{t('service.identifyDevice.subtitle')}</p>
      {showManual ? (
        <ManualEntry onScanBarcode={handleSwitchToScanner} onValidityChange={setIsNextEnabled} />
      ) : (
        <BarcodeScanner onEnterManually={handleSwitchToManual} onValidityChange={setIsNextEnabled} />
      )}
      <div className="identify-device__actions">
        <KccButton
          className="identify-device__next-btn"
          disabled={!isNextEnabled}
          icon={<SvgIcon name="rightArrow" className="identify-device__next-btn-icon" />}
          iconPosition="end"
          onClick={handleAddServiceCaseNext}
          type="secondary"
        >
          {t('service.identifyDevice.nextButton')}
        </KccButton>
      </div>
    </StyledIdentifyDevice>
  );
};
